/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthorityRouteImport } from './routes/authority'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as CircleRouteImport } from './routes/circle'
import { Route as CurationRouteImport } from './routes/curation'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as FollowupRouteImport } from './routes/followup'
import { Route as FundingRouteImport } from './routes/funding'
import { Route as HomeRouteImport } from './routes/home'
import { Route as IcpRouteImport } from './routes/icp'
import { Route as IcpProfileRouteImport } from './routes/icp-profile'
import { Route as IntakeRouteImport } from './routes/intake'
import { Route as InterestsRouteImport } from './routes/interests'
import { Route as LearningRouteImport } from './routes/learning'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MapRouteImport } from './routes/map'
import { Route as MatchesRouteImport } from './routes/matches'
import { Route as PathRouteImport } from './routes/path'
import { Route as PrepRouteImport } from './routes/prep'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RadarRouteImport } from './routes/radar'
import { Route as PersonIdRouteImport } from './routes/person.$id'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsSupportRouteImport } from './routes/settings.support'
import { Route as TrackGoalRouteImport } from './routes/track.$goal'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorityRoute = AuthorityRouteImport.update({
  id: '/authority',
  path: '/authority',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefRoute = BriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const CircleRoute = CircleRouteImport.update({
  id: '/circle',
  path: '/circle',
  getParentRoute: () => rootRouteImport,
} as any)
const CurationRoute = CurationRouteImport.update({
  id: '/curation',
  path: '/curation',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowupRoute = FollowupRouteImport.update({
  id: '/followup',
  path: '/followup',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingRoute = FundingRouteImport.update({
  id: '/funding',
  path: '/funding',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IcpRoute = IcpRouteImport.update({
  id: '/icp',
  path: '/icp',
  getParentRoute: () => rootRouteImport,
} as any)
const IcpProfileRoute = IcpProfileRouteImport.update({
  id: '/icp-profile',
  path: '/icp-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeRoute = IntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => rootRouteImport,
} as any)
const InterestsRoute = InterestsRouteImport.update({
  id: '/interests',
  path: '/interests',
  getParentRoute: () => rootRouteImport,
} as any)
const LearningRoute = LearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const MatchesRoute = MatchesRouteImport.update({
  id: '/matches',
  path: '/matches',
  getParentRoute: () => rootRouteImport,
} as any)
const PathRoute = PathRouteImport.update({
  id: '/path',
  path: '/path',
  getParentRoute: () => rootRouteImport,
} as any)
const PrepRoute = PrepRouteImport.update({
  id: '/prep',
  path: '/prep',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RadarRoute = RadarRouteImport.update({
  id: '/radar',
  path: '/radar',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonIdRoute = PersonIdRouteImport.update({
  id: '/person/$id',
  path: '/person/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/settings/connections',
  path: '/settings/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSupportRoute = SettingsSupportRouteImport.update({
  id: '/settings/support',
  path: '/settings/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackGoalRoute = TrackGoalRouteImport.update({
  id: '/track/$goal',
  path: '/track/$goal',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authority': typeof AuthorityRoute
  '/brief': typeof BriefRoute
  '/calendar': typeof CalendarRoute
  '/circle': typeof CircleRoute
  '/curation': typeof CurationRoute
  '/feed': typeof FeedRoute
  '/followup': typeof FollowupRoute
  '/funding': typeof FundingRoute
  '/home': typeof HomeRoute
  '/icp': typeof IcpRoute
  '/icp-profile': typeof IcpProfileRoute
  '/intake': typeof IntakeRoute
  '/interests': typeof InterestsRoute
  '/learning': typeof LearningRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/matches': typeof MatchesRoute
  '/path': typeof PathRoute
  '/prep': typeof PrepRoute
  '/profile': typeof ProfileRoute
  '/radar': typeof RadarRoute
  '/person/$id': typeof PersonIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/track/$goal': typeof TrackGoalRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authority': typeof AuthorityRoute
  '/brief': typeof BriefRoute
  '/calendar': typeof CalendarRoute
  '/circle': typeof CircleRoute
  '/curation': typeof CurationRoute
  '/feed': typeof FeedRoute
  '/followup': typeof FollowupRoute
  '/funding': typeof FundingRoute
  '/home': typeof HomeRoute
  '/icp': typeof IcpRoute
  '/icp-profile': typeof IcpProfileRoute
  '/intake': typeof IntakeRoute
  '/interests': typeof InterestsRoute
  '/learning': typeof LearningRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/matches': typeof MatchesRoute
  '/path': typeof PathRoute
  '/prep': typeof PrepRoute
  '/profile': typeof ProfileRoute
  '/radar': typeof RadarRoute
  '/person/$id': typeof PersonIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/track/$goal': typeof TrackGoalRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/authority': typeof AuthorityRoute
  '/brief': typeof BriefRoute
  '/calendar': typeof CalendarRoute
  '/circle': typeof CircleRoute
  '/curation': typeof CurationRoute
  '/feed': typeof FeedRoute
  '/followup': typeof FollowupRoute
  '/funding': typeof FundingRoute
  '/home': typeof HomeRoute
  '/icp': typeof IcpRoute
  '/icp-profile': typeof IcpProfileRoute
  '/intake': typeof IntakeRoute
  '/interests': typeof InterestsRoute
  '/learning': typeof LearningRoute
  '/login': typeof LoginRoute
  '/map': typeof MapRoute
  '/matches': typeof MatchesRoute
  '/path': typeof PathRoute
  '/prep': typeof PrepRoute
  '/profile': typeof ProfileRoute
  '/radar': typeof RadarRoute
  '/person/$id': typeof PersonIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/track/$goal': typeof TrackGoalRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authority'
    | '/brief'
    | '/calendar'
    | '/circle'
    | '/curation'
    | '/feed'
    | '/followup'
    | '/funding'
    | '/home'
    | '/icp'
    | '/icp-profile'
    | '/intake'
    | '/interests'
    | '/learning'
    | '/login'
    | '/map'
    | '/matches'
    | '/path'
    | '/prep'
    | '/profile'
    | '/radar'
    | '/person/$id'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/support'
    | '/track/$goal'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authority'
    | '/brief'
    | '/calendar'
    | '/circle'
    | '/curation'
    | '/feed'
    | '/followup'
    | '/funding'
    | '/home'
    | '/icp'
    | '/icp-profile'
    | '/intake'
    | '/interests'
    | '/learning'
    | '/login'
    | '/map'
    | '/matches'
    | '/path'
    | '/prep'
    | '/profile'
    | '/radar'
    | '/person/$id'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/support'
    | '/track/$goal'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/authority'
    | '/brief'
    | '/calendar'
    | '/circle'
    | '/curation'
    | '/feed'
    | '/followup'
    | '/funding'
    | '/home'
    | '/icp'
    | '/icp-profile'
    | '/intake'
    | '/interests'
    | '/learning'
    | '/login'
    | '/map'
    | '/matches'
    | '/path'
    | '/prep'
    | '/profile'
    | '/radar'
    | '/person/$id'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/support'
    | '/track/$goal'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthorityRoute: typeof AuthorityRoute
  BriefRoute: typeof BriefRoute
  CalendarRoute: typeof CalendarRoute
  CircleRoute: typeof CircleRoute
  CurationRoute: typeof CurationRoute
  FeedRoute: typeof FeedRoute
  FollowupRoute: typeof FollowupRoute
  FundingRoute: typeof FundingRoute
  HomeRoute: typeof HomeRoute
  IcpRoute: typeof IcpRoute
  IcpProfileRoute: typeof IcpProfileRoute
  IntakeRoute: typeof IntakeRoute
  InterestsRoute: typeof InterestsRoute
  LearningRoute: typeof LearningRoute
  LoginRoute: typeof LoginRoute
  MapRoute: typeof MapRoute
  MatchesRoute: typeof MatchesRoute
  PathRoute: typeof PathRoute
  PrepRoute: typeof PrepRoute
  ProfileRoute: typeof ProfileRoute
  RadarRoute: typeof RadarRoute
  PersonIdRoute: typeof PersonIdRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsSupportRoute: typeof SettingsSupportRoute
  TrackGoalRoute: typeof TrackGoalRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authority': {
      id: '/authority'
      path: '/authority'
      fullPath: '/authority'
      preLoaderRoute: typeof AuthorityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brief': {
      id: '/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof BriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circle': {
      id: '/circle'
      path: '/circle'
      fullPath: '/circle'
      preLoaderRoute: typeof CircleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curation': {
      id: '/curation'
      path: '/curation'
      fullPath: '/curation'
      preLoaderRoute: typeof CurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/followup': {
      id: '/followup'
      path: '/followup'
      fullPath: '/followup'
      preLoaderRoute: typeof FollowupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding': {
      id: '/funding'
      path: '/funding'
      fullPath: '/funding'
      preLoaderRoute: typeof FundingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icp': {
      id: '/icp'
      path: '/icp'
      fullPath: '/icp'
      preLoaderRoute: typeof IcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icp-profile': {
      id: '/icp-profile'
      path: '/icp-profile'
      fullPath: '/icp-profile'
      preLoaderRoute: typeof IcpProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake': {
      id: '/intake'
      path: '/intake'
      fullPath: '/intake'
      preLoaderRoute: typeof IntakeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interests': {
      id: '/interests'
      path: '/interests'
      fullPath: '/interests'
      preLoaderRoute: typeof InterestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learning': {
      id: '/learning'
      path: '/learning'
      fullPath: '/learning'
      preLoaderRoute: typeof LearningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/matches': {
      id: '/matches'
      path: '/matches'
      fullPath: '/matches'
      preLoaderRoute: typeof MatchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/path': {
      id: '/path'
      path: '/path'
      fullPath: '/path'
      preLoaderRoute: typeof PathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prep': {
      id: '/prep'
      path: '/prep'
      fullPath: '/prep'
      preLoaderRoute: typeof PrepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/radar': {
      id: '/radar'
      path: '/radar'
      fullPath: '/radar'
      preLoaderRoute: typeof RadarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/person/$id': {
      id: '/person/$id'
      path: '/person/$id'
      fullPath: '/person/$id'
      preLoaderRoute: typeof PersonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/settings/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/support': {
      id: '/settings/support'
      path: '/settings/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof SettingsSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/track/$goal': {
      id: '/track/$goal'
      path: '/track/$goal'
      fullPath: '/track/$goal'
      preLoaderRoute: typeof TrackGoalRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthorityRoute: AuthorityRoute,
  BriefRoute: BriefRoute,
  CalendarRoute: CalendarRoute,
  CircleRoute: CircleRoute,
  CurationRoute: CurationRoute,
  FeedRoute: FeedRoute,
  FollowupRoute: FollowupRoute,
  FundingRoute: FundingRoute,
  HomeRoute: HomeRoute,
  IcpRoute: IcpRoute,
  IcpProfileRoute: IcpProfileRoute,
  IntakeRoute: IntakeRoute,
  InterestsRoute: InterestsRoute,
  LearningRoute: LearningRoute,
  LoginRoute: LoginRoute,
  MapRoute: MapRoute,
  MatchesRoute: MatchesRoute,
  PathRoute: PathRoute,
  PrepRoute: PrepRoute,
  ProfileRoute: ProfileRoute,
  RadarRoute: RadarRoute,
  PersonIdRoute: PersonIdRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsSupportRoute: SettingsSupportRoute,
  TrackGoalRoute: TrackGoalRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
